import { render } from "./tab-loading.vue?vue&type=template&id=20b13407&scoped=true"
const script = {}

import "./tab-loading.vue?vue&type=style&index=0&id=20b13407&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b13407"]])

export default __exports__